import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { "txt-center": "" }
const _hoisted_2 = { "m-t-2": "" }
const _hoisted_3 = {
  key: 0,
  "m-t-4": ""
}
const _hoisted_4 = {
  key: 1,
  "m-t-4": ""
}
const _hoisted_5 = { "txt-center": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_app_section_divider = _resolveComponent("app-section-divider")!
  const _component_app_skill_input = _resolveComponent("app-skill-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      "custom-class": "App-User-Profile-Modal App-Unpadded",
      "model-value": _ctx.isModalOpen,
      width: "550px",
      "show-close": _ctx.showClose,
      onOpen: _ctx.opened,
      title: "Skills",
      center: "",
      "close-on-click-modal": _ctx.showClose,
      "append-to-body": true,
      "lock-scroll": true,
      "open-delay": 200,
      "close-delay": 200,
      "before-close": _ctx.closeModal,
      "close-on-press-escape": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            "is-block": "",
            icon: "el-icon-check",
            onClick: _ctx.submit,
            size: "large",
            type: "primary",
            disabled: _ctx.disabledSave || _ctx.loading
          }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
              _createTextVNode(" Save Skills ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_scrollbar, {
          always: true,
          "max-height": "600px"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", null, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_el_image, {
                    style: `width: 150px;`,
                    src: _ctx.img
                  }, null, 8, ["src"]),
                  _cache[4] || (_cache[4] = _createElementVNode("p", null, " Tell us about your core skills ", -1))
                ])
              ]),
              _createVNode(_component_el_form, {
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
                class: "App-Styled-Form",
                "label-position": 'top',
                "label-width": "100px",
                model: _ctx.form,
                style: {"margin-top":"12px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "areaOfExpertise",
                    label: "What are you exceptionally good at? (Superpower)"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        placeholder: "Marketing Expert",
                        modelValue: _ctx.form.areaOfExpertise,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.areaOfExpertise) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", null, [
                    _createVNode(_component_app_section_divider, { content: "Main skills" }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createElementVNode("i", { class: "el-icon-wok" }, null, -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_el_space, {
                        size: 12,
                        fill: "",
                        direction: "vertical"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.skills, (skill, index) => {
                            return (_openBlock(), _createBlock(_component_el_row, {
                              key: index,
                              gutter: 12
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, { span: 14 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_app_skill_input, {
                                      modelValue: _ctx.form.skills[index].name,
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.form.skills[index].name) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_col, { span: 10 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      prop: "experience",
                                      label: "Years of experience"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input_number, {
                                          "w-100": "",
                                          min: 0,
                                          max: 100,
                                          controls: false,
                                          placeholder: "EX: 5",
                                          modelValue: _ctx.form.skills[index].years,
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.form.skills[index].years) = $event)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_space, {
                        wrap: "",
                        size: 16
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            class: "button-new-tag",
                            size: "small",
                            onClick: _ctx.addMainSkill,
                            round: "",
                            icon: "el-icon-plus"
                          }, {
                            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                              _createTextVNode(" Add Main Skill ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_el_button, {
                            class: "button-new-tag",
                            size: "small",
                            onClick: _ctx.removeMainSkill,
                            round: "",
                            icon: "el-icon-remove"
                          }, {
                            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                              _createTextVNode(" Remove Last Skill ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  false
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_app_section_divider, { content: "Other Skills" }, {
                          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                            _createElementVNode("i", { class: "el-icon-wok" }, null, -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[10] || (_cache[10] = _createElementVNode("div", { "m-tb-2": "" }, null, -1)),
                        _createElementVNode("div", null, [
                          _createVNode(_component_el_space, {
                            wrap: "",
                            "m-b-1": "",
                            size: 12
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.otherSkills, (tag) => {
                                return (_openBlock(), _createBlock(_component_el_tag, {
                                  key: `skill-${tag}`,
                                  "tag-default": "",
                                  "is-all-borderless": "",
                                  closable: "",
                                  "disable-transitions": false,
                                  onClose: ($event: any) => (_ctx.handleCloseSkill(tag))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(tag), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClose"]))
                              }), 128))
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", null, [
                            (_ctx.tempForm.inputSkill)
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 0,
                                  style: {"display":"inline-block"},
                                  prop: "description"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      ref: "saveTagInputSkill",
                                      modelValue: _ctx.tempForm.skill,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tempForm.skill) = $event)),
                                      class: "input-new-tag",
                                      placeholder: "Enter Skill Name",
                                      onKeyup: _withKeys(_ctx.handleInputConfirmSkill, ["enter"]),
                                      onBlur: _ctx.handleInputConfirmSkill
                                    }, null, 8, ["modelValue", "onKeyup", "onBlur"])
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_el_button, {
                                  key: 1,
                                  "m-tb-1": "",
                                  class: "button-new-tag",
                                  size: "small",
                                  onClick: _ctx.showInputSkill,
                                  round: "",
                                  icon: "el-icon-plus"
                                }, {
                                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                    _createTextVNode(" Add Other Skill ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"]))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  false
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_app_section_divider, { content: "Passions" }, {
                          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                            _createElementVNode("i", { class: "el-icon-wok" }, null, -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[13] || (_cache[13] = _createElementVNode("div", { "m-tb-2": "" }, null, -1)),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_el_space, {
                              wrap: "",
                              "m-b-1": "",
                              size: 12
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.interests, (tag) => {
                                  return (_openBlock(), _createBlock(_component_el_tag, {
                                    key: `interest-${tag}`,
                                    "tag-default": "",
                                    "is-all-borderless": "",
                                    closable: "",
                                    "disable-transitions": false,
                                    onClose: ($event: any) => (_ctx.handleCloseInterest(tag))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(tag), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClose"]))
                                }), 128))
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", null, [
                              (_ctx.tempForm.inputInterest)
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 0,
                                    style: {"display":"inline-block"},
                                    prop: "description"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        ref: "saveTagInputInterest",
                                        modelValue: _ctx.tempForm.interest,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tempForm.interest) = $event)),
                                        class: "input-new-tag",
                                        placeholder: "Passion",
                                        onKeyup: _withKeys(_ctx.handleInputConfirmInterest, ["enter"]),
                                        onBlur: _ctx.handleInputConfirmInterest
                                      }, null, 8, ["modelValue", "onKeyup", "onBlur"])
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_el_button, {
                                    key: 1,
                                    "m-tb-1": "",
                                    class: "button-new-tag",
                                    size: "small",
                                    onClick: _ctx.showInputInterest,
                                    round: "",
                                    icon: "el-icon-plus"
                                  }, {
                                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                      _createTextVNode(" Add Passion ", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["onClick"]))
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["model"])
            ])), [
              [_directive_loading, _ctx.loading]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model-value", "show-close", "onOpen", "close-on-click-modal", "before-close"])
  ]))
}